import { useEffect } from "react";
import { setThemeBarColors } from "../utils";
import { defaultThemeBarColor } from "../theme";

/**
 * Applies device status-bar / bottom-bar colors while a screen is mounted, then
 * restores the app defaults (tenant primary status, white bottom) on unmount.
 * The bottom bar stays white unless `bottomBarColor` is given.
 *
 * Example: useThemeBarColors("#151515", "#151515") — dark bars for the landing screen.
 */
export const useThemeBarColors = (statusBarColor: string, bottomBarColor?: string) => {
  useEffect(() => {
    setThemeBarColors(statusBarColor, bottomBarColor);
    return () => {
      setThemeBarColors(defaultThemeBarColor);
    };
  }, [statusBarColor, bottomBarColor]);
};
